export const socialsData = {
    github: 'https://github.com/mdarshadkhan1998',
    facebook: 'https://www.facebook.com/people/Arshad-Khan/100004164048208/',
    linkedIn: 'https://www.linkedin.com/in/md-arshad-khan-350206154/',
    instagram: 'https://www.instagram.com/_mad___boxer_/',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@mdarshadkhan1998',
    stackOverflow: '',
    gitlab: '',
    youtube: 'https://www.youtube.com/channel/UCGK-satop1PZ9njUOYCzHJw'
}